<template>
	<div class="cyBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @callFn="fxFlag = false" :title="`您正在获取班级课本`">
			<p class="fxP">请选择需要获取的课本</p>
			<el-form :model="form" style="width: 430px" label-width="60px">
				<el-form-item label="课 本">
					<el-select style="width: 100%" v-model="form.bjNum" filterable allow-create default-first-option placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<dialogBox :dialogFlag="delFlag" rigTxt="确认删除" rigBg="#D33931" @callFn="delFlag = false" :title="''">
			<div class="delBox">
				<img src="@/assets/img/sc (6).png" alt="" />
				<h2>删除试卷后将无法恢复</h2>
				<p>是否确定删除</p>
			</div>
		</dialogBox>
		<div class="cyTop">
			<div class="cyDelBtn" @click="delQbFn">
				<img src="@/assets/img/编组 (11).svg" alt="" />
				全部删除
			</div>
		</div>
		<div class="cyCont">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" header-row-class-name="btClass" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" prop="status" :selectable="checkSelectable" width="80"></el-table-column>
				<el-table-column align="center" prop="title" label="试卷名">
					<template slot-scope="scope">
						<div class="spBox" @click="lookBtn(scope.row)">
							{{ scope.row.title }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="报告" align="center">
					<template slot-scope="scope">
						<div class="iconBox" @click="ctFn(scope.row)">
							<img src="@/assets/img/ctfb.svg" class="ztIcon" alt="" />
							错题分布
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';

export default {
	name: 'meiriYts',
	data() {
		return {
			tableData: [],
			form: {
				bjNum: ''
			},
			delFlag: false,
			fxFlag: false,
			fullscreenLoading: false,
			options: [],
			tabFlag: 1,
			multipleSelection: []
		};
	},
	components: {
		dialogBox
	},
	props: ['bjId', 'a'],
	methods: {
		lookBtn(item) {
			console.log('item: ',item);
			this.$router.push({
				path: './timDec',
				query: {
					type: 1,
					// types: 'zt',
					txt: item.title,
					tabFtxt: this.a,
					listenEveryDayId: item.examId,
					crumFlag: 1,
					tabFtxt: ['首页', '每日一听']
				}
			});
		},
		decFn() {
			this.$emit('fhBtn', 'kebenDec');
		},
		delQbFn() {
			if (this.multipleSelection.length) {
				let str = '';
				let strName = '';
				for (let item of this.multipleSelection) {
					str += item.bjExamId + ',';
					strName += item.title + ',';
				}
				this.$confirm(`是否删除${strName.substring(0, strName.length - 1)}?`, '提示', {
					confirmButtonText: '确认',
					confirmButtonClass: 'delBtns',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						console.log(str);
						let set = this.$loading(this.$pre);
						this.$http.delete(`api/app/yydBjExam/${str.substring(0, str.length - 1)}`).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.init();
							}
						});
					})
					.catch(() => {});
			} else {
				this.$message({
					message: '请选择试卷',
					type: 'warning'
				});
			}
			console.log(this.multipleSelection);
		},
		ctFn(item) {
			this.$emit('ctFn', item.bjExamId);
			this.$emit('fbBtn', item.examId, 2);
			this.$emit('fhBtn', 'banjiSjDecSec');
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		checkSelectable(row) {
			return !row.status;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydBjExam/list/${this.bjId}/2`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.tableData = res.rows || [];
				}
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
	.spBox {
		cursor: pointer;
	}
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.fxP {
	font-size: 14px;
	text-align: center;
	margin-bottom: 33px;
}
.cyBox {
	background: #ffffff;
	border-radius: 6px;
	.cyTop {
		height: 80px;
		padding: 0 21px 0 16px;
		display: flex;
		align-items: center;
		position: relative;
		justify-content: end;
		border-bottom: 1px solid #eeeff2;
		.cyDelBtn {
			width: 90px;
			height: 30px;
			background: rgba(247, 85, 45, 0.05);
			border: 1px solid #f7552d;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #f7552d;
			cursor: pointer;
			img {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}
		}
		.cyDelBtns {
			color: #fff;
			background: #1d7b3a;
			border: 1px solid #1d7b3a;
			img {
				width: 12px;
				height: 15px;
				margin-right: 4px;
			}
		}
	}
}
.imgs {
	width: 44px;
	height: 55px;
	background: #d8d8d8;
	border-radius: 4px;
}
.iconBox {
	display: flex;
	align-items: center;
	color: #fa4a1b;
	font-size: 14px;
	justify-content: center;
	cursor: pointer;
	img {
		width: 15px;
		height: 15px;
		margin-right: 6px;
	}
}
.delBox {
	text-align: center;
	img {
		width: 70px;
		height: 70px;
		margin-bottom: 39px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9d9d9d;
		font-size: 16px;
	}
}
.nydBox {
	width: 53px;
	height: 30px;
	border: 1px solid #1d7b3a;
	font-size: 14px;
	color: #1d7b3a;
	text-align: center;
	line-height: 30px;
	border-radius: 6px;
	margin: 0 auto;
}
</style>
